
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recover",
      function () {
        return require("private-next-pages/recover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recover"])
      });
    }
  